import {ContractorInvoicesDao} from '../../dao';
import {ErrorModel} from '../../models';
import {SERVICE_CODE} from './_serviceCode';
const FUNCTION_CODE = 'GET_ALL_CONTRACTOR_INVOICES';

export async function getContractorInvoices(
    userData: Record<string, string>,
    params: string
) {
    try {
        const result = await ContractorInvoicesDao.getContractorInvoices(userData.userToken, params);

        const metadata = {
            count: result.count,
            next: result.next,
            previous: result.previous
        };

        return {
            metadata,
            data: result.results
        };
    }
    catch (error) {
        throw ErrorModel.newError({
            code: `${SERVICE_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue.',
            error: error
        });
    }
}
